import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '../../../components/ui/dialog';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';

const AddNewColumnModel = ({ isOpen, onClose, onSave, isLoading = false }) => {
  const { t } = useTranslation();
  const [columnName, setColumnName] = useState('');

  const handleSave = () => {
    if (columnName.trim()) {
      onSave(columnName);
      setColumnName('');
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={t('app:crm.t3')}
    >
      <Input
          multi={false} // Disable tokens
          value={columnName}
          onChange={(e) => setColumnName(e.target.value)}
          placeholder={t('app:crm.t6')}
          className="w-full"
        />
      <div className="mt-8 flex justify-end space-x-4">
        <Button onClick={onClose} size="sm" variant="outline" disabled={isLoading}>{t('app:crm.t5')}</Button>
        <Button onClick={handleSave} size="sm" disabled={isLoading}>{t('app:crm.t4')}</Button>
      </div>
    </Dialog>
  );
};

export default AddNewColumnModel;
